// @flow
import React from 'react';
import Modal from 'react-modal';
import SimpleBar from 'simplebar-react';
import { JobApplicationForm } from 'components/organisms/jobApplicationForm';
import { useViewport } from 'components/templates/viewportProvider';
import chevronRightIcon from 'assets/images/rightb.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  isOpen: boolean,
  onClosePress: () => void,
  roleName?: string,
};

export const JobApplicationModal = (props: Props) => {
  const { isMobile } = useViewport();
  const { isOpen, onClosePress, roleName, jobEmail } = props;

  const onClose = () => {
    onClosePress();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClosePress}
      overlayClassName={'modal-overlay normal-scroll'}
      className={`job-application-overlay-content ${isMobile ? 'mobile' : ''}`}
    >
      <div className={'job-application-modal'}>
        <a className={'collapse-icon-container'} onClick={onClose}>
          <img src={chevronRightIcon} alt={'icon'} />
        </a>
        <SimpleBar autoHide={true} style={{ height: '100%' }}>
          <div>
            <span className={'label'}>Apply for the Role</span>
            <h2>Upload your information</h2>
            <h3>We'll soon reach out to you.</h3>
          </div>
          <JobApplicationForm
            roleName={roleName}
            onSubmitSuccess={onClose}
            isMobile={isMobile}
            jobEmail={jobEmail}
          />
        </SimpleBar>
      </div>
    </Modal>
  );
};
